"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popup = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var dom_helpers_1 = require("../util/dom-helpers");
var query_1 = require("../util/dom-helpers/query");
var camelize_style_1 = require("../util/dom-helpers/util/camelize-style");
var classnames_1 = require("../util/classnames");
var compat_1 = require("../util/compat");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var animate_1 = __importDefault(require("../util/dom/animate"));
var transform = camelize_style_1.camelizeStyle(animate_1.default.transform);
var CLOSING = 0;
var CLOSED = 1;
var OPENING = 2;
var OPEN = 3;
function childKey(children) {
  var nextChildMapping = react_1.default.Children.map(children, function (c) {
    return c;
  });
  for (var key in nextChildMapping) {
    return key;
  }
}
function properties(prop, value) {
  var _a, _b;
  var TRANSLATION_MAP = animate_1.default.TRANSLATION_MAP;
  if (TRANSLATION_MAP && TRANSLATION_MAP[prop]) {
    return _a = {}, _a[transform] = TRANSLATION_MAP[prop] + "(" + value + ")", _a;
  }
  return _b = {}, _b[prop] = value, _b;
}
var OVERFLOW = (_a = {}, _a[CLOSED] = 'hidden', _a[CLOSING] = 'hidden', _a[OPENING] = 'hidden', _a);
var Popup = /** @class */function (_super) {
  __extends(Popup, _super);
  function Popup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      initialRender: true,
      status: _this.props.open ? OPENING : CLOSED
    };
    _this._isdropUp = false;
    _this.close = function () {
      _this.cancelNextCallback();
      var el = react_dom_1.default.findDOMNode(_this).firstChild;
      var height = _this.height();
      if (_this.props.onClosing) {
        _this.props.onClosing();
      }
      _this.safeSetState({
        status: CLOSING,
        height: height
      }, function () {
        var offset = _this.getOffsetForStatus(CLOSED);
        var duration = _this.props.duration;
        _this.animate(el, offset, duration, 'ease', function () {
          _this.safeSetState({
            status: CLOSED
          }, function () {
            if (_this.props.onClose) {
              _this.props.onClose();
            }
          });
        });
      });
    };
    _this.move = function () {
      // Calculates the space available before the popup and renders it above its
      // parent when there isn't enough room. If there isnt enough room above the parent,
      // it will render below.
      var status = _this.state.status;
      var dropdown = _this._popup;
      if (dropdown) {
        _this._isdropUp = false;
        dropdown.style.top = '';
        var dropdownParentHeight = (dropdown === null || dropdown === void 0 ? void 0 : dropdown.parentNode).clientHeight;
        var dropdownPosition = dropdown.getBoundingClientRect();
        var screenHeight = window.innerHeight;
        var availableSpaceForDropdownBelow = screenHeight - (dropdownPosition.top + dropdownParentHeight);
        var availableSpaceForDropdownAbove = dropdownPosition.top;
        if (status === (2 || 1)) {
          if (availableSpaceForDropdownBelow <= dropdownPosition.height) {
            if (availableSpaceForDropdownAbove <= dropdownPosition.height) {
              return;
            }
            if (_this.props.dropUp === undefined || _this.props.dropUp) {
              dropdown.style.top = '-' + (dropdownPosition.height + 12) + 'px';
              _this._isdropUp = true;
            }
          }
        }
      }
    };
    _this.getOffsetForStatus = function (status) {
      var _a;
      var _b = _this.props,
        dropUp = _b.dropUp,
        arrow = _b.arrow;
      if (_this.state.initialRender) {
        return {};
      }
      var top = 0;
      if (dropUp && arrow) {
        top = '120px';
      } else if (!dropUp && arrow) {
        top = 'calc(-100% - 17px)';
      } else if (dropUp && !arrow || _this._isdropUp) {
        top = '100%';
      } else if (!dropUp && !arrow) {
        top = '-100%';
      }
      var _in = properties('top', top);
      var out = properties('top', 0);
      return (_a = {}, _a[CLOSED] = _in, _a[CLOSING] = out, _a[OPENING] = _in, _a[OPEN] = out, _a)[status] || {};
    };
    _this.height = function () {
      var container = react_dom_1.default.findDOMNode(_this);
      var content = container.firstChild;
      var margin = parseInt(dom_helpers_1.getCss(content, 'margin-top'), 10) + parseInt(dom_helpers_1.getCss(content, 'margin-bottom'), 10);
      var old = container.style.display;
      container.style.display = 'block';
      var height = (query_1.height(content) || 0) + (isNaN(margin) ? 0 : margin);
      container.style.display = old;
      return height;
    };
    _this.isTransitioning = function () {
      return _this.state.status === OPENING || _this.state.status === CLOSED;
    };
    _this.animate = function (el, props, dur, easing, cb) {
      _this._transition = animate_1.default.animate(el, props, dur, easing, _this.setNextCallback(cb));
    };
    _this.cancelNextCallback = function () {
      if (_this._transition && _this._transition.cancel) {
        _this._transition.cancel();
        _this._transition = null;
      }
      if (_this.nextCallback) {
        _this.nextCallback.cancel();
        _this.nextCallback = undefined;
      }
    };
    _this.safeSetState = function (nextState, callback) {
      _this.setState(nextState, _this.setNextCallback(callback));
    };
    _this.setNextCallback = function (callback) {
      var active = true;
      _this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this.nextCallback = undefined;
          callback(event);
        }
      };
      _this.nextCallback.cancel = function () {
        return active = false;
      };
      return _this.nextCallback;
    };
    _this.renderChildren = function () {
      var _a;
      var _b = _this.props,
        arrow = _b.arrow,
        children = _b.children;
      var popupContentClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('popup__content')] = true, _a[vdl_prefix_1.vdlPrefix('popup__content--arrow')] = arrow, _a);
      var offset = _this.getOffsetForStatus(_this.state.status);
      var arrowClass = _this._isdropUp ? vdl_prefix_1.vdlPrefix('popup__arrow--down') : vdl_prefix_1.vdlPrefix('popup__arrow--up');
      var style = Object.assign({}, offset, {
        position: _this.isTransitioning() ? 'absolute' : undefined
      });
      var PopupArrow = function PopupArrow(props) {
        return react_1.default.createElement("div", __assign({}, props, {
          className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('popup__arrow'), arrowClass)
        }));
      };
      return react_1.default.createElement("div", {
        className: classnames_1.classNames(popupContentClasses),
        style: style
      }, arrow && react_1.default.createElement(PopupArrow, null), children);
    };
    return _this;
  }
  Popup.prototype.componentDidMount = function () {
    var _this = this;
    var isOpen = this.state.status === OPENING;
    compat_1.batchedUpdates(function () {
      _this.setState({
        initialRender: false
      });
      if (isOpen) {
        _this.open();
      }
    });
    window.addEventListener('resize', this.move.bind(this));
  };
  Popup.prototype.componentWillReceiveProps = function (nextProps) {
    this.setState({
      contentChanged: childKey(nextProps.children) !== childKey(this.props.children)
    });
  };
  Popup.prototype.componentDidUpdate = function (pvProps) {
    var closing = pvProps.open && !this.props.open;
    var opening = !pvProps.open && this.props.open;
    var open = this.props.open;
    var status = this.state.status;
    if (!!pvProps.dropUp !== !!this.props.dropUp) {
      this.cancelNextCallback();
      if (status === OPENING) {
        this.open();
      }
      if (status === CLOSING) {
        this.close();
      }
      return;
    }
    if (opening) {
      this.open();
    } else if (closing) {
      this.close();
    } else if (open) {
      var height = this.height();
      if (height !== this.state.height) {
        this.setState({
          height: height
        });
      }
    }
  };
  Popup.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.move.bind(this));
  };
  Popup.prototype.open = function () {
    var _this = this;
    this.cancelNextCallback();
    var el = react_dom_1.default.findDOMNode(this).firstChild;
    var height = this.height();
    if (this.props.onOpening) {
      this.props.onOpening();
    }
    this.safeSetState({
      status: OPENING,
      height: height
    }, function () {
      var offset = _this.getOffsetForStatus(OPEN);
      var duration = 0;
      _this.move();
      _this.animate(el, offset, duration, 'ease', function () {
        _this.safeSetState({
          status: OPEN
        }, function () {
          if (_this.props.onOpen) {
            _this.props.onOpen();
          }
        });
      });
    });
  };
  Popup.prototype.render = function () {
    var _a;
    var _this = this;
    var _b = this.props,
      className = _b.className,
      dropUp = _b.dropUp,
      arrow = _b.arrow,
      style = _b.style;
    var _c = this.state,
      status = _c.status,
      height = _c.height;
    var overflow = OVERFLOW[status] || 'visible';
    var display = status === CLOSED ? 'none' : 'block';
    var popupClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('popup')] = true, _a[vdl_prefix_1.vdlPrefix('popup--dropup')] = dropUp, _a[vdl_prefix_1.vdlPrefix('popup--arrow')] = arrow, _a[vdl_prefix_1.vdlPrefix('popup--animate')] = this.isTransitioning(), _a);
    var customProps = _1.omit(this.props, Object.keys(Popup.propTypes));
    return react_1.default.createElement("div", __assign({}, customProps, {
      ref: function ref(c) {
        _this._popup = c;
      },
      style: Object.assign({}, {
        display: display,
        overflow: overflow,
        height: height
      }, style),
      className: classnames_1.classNames(className, popupClasses)
    }), this.renderChildren());
  };
  Popup.propTypes = {
    open: prop_types_1.default.bool,
    dropUp: prop_types_1.default.bool,
    duration: prop_types_1.default.number,
    onClosing: prop_types_1.default.func,
    onOpening: prop_types_1.default.func,
    onClose: prop_types_1.default.func,
    onOpen: prop_types_1.default.func,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    arrow: prop_types_1.default.bool,
    style: prop_types_1.default.object
  };
  Popup.defaultProps = {
    duration: 200,
    open: false,
    arrow: false
  };
  return Popup;
}(react_1.default.Component);
exports.Popup = Popup;